import React, { useContext, useEffect, useState } from "react";
import * as Icon from "react-bootstrap-icons";
import { AppStateContext } from "../Context/contextState";
import ShareProject from "../GelobalComponents/ModalShare";
import "./projectPage.css";
import Canvas from "../GelobalComponents/Canvas";
import LoadingModel from "../GelobalComponents/LoadingModel";
import Toasts from "../GelobalComponents/Toasts";

export default function FilePage() {
  const {
    loading,
    setLoading,
    projectTitle,
    setProjectTitle,
    fileDetail,
    setFileDetail,
  } = useContext(AppStateContext);

  const [toastsShow, setToastsShow] = useState(false);
  const [toastsShowBack, setToastsShowBack] = useState();
  const [toastsText, setToastsText] = useState();

  const loadingPage = () => {
    setLoading(true);
  };

  const getDetailFile = async () => {
    loadingPage();
    const saveFileId = localStorage.getItem("fileId");
    const saveFilePath = localStorage.getItem("filePath");
    const saveFileTitle = localStorage.getItem("fileTitle");
    const savedProjectTitle = localStorage.getItem("projectTitle");
    const savedFileCode = localStorage.getItem("fileCode");
    if (saveFileId && saveFilePath) {
      await setFileDetail({
        fileId: saveFileId,
        filePath: saveFilePath,
        fileTitle: saveFileTitle,
        fileCode: savedFileCode,
      });

      setProjectTitle(savedProjectTitle);
    }
  };

  useEffect(() => {
    getDetailFile();
  }, []);

  console.log("fileDetail?.fileCode>>", fileDetail?.fileCode);

  return (
    <>
      <div className="ProjectPage">
        <div className="ProjectPage-heading">
          <div className="Header-container-canvas">
            <div className="ProjectPage-title d-flex align-items-center">
              <h4>نمای سه بعدی</h4>
              <p>
                پروژه ها <Icon.ArrowLeftShort color="inherit" />
                {projectTitle}
                <Icon.ArrowLeftShort color="inherit" />
                فایل
                {fileDetail?.fileTitle}
              </p>
            </div>
            <div className="Share-btn">
              <ShareProject fileCodeParam={fileDetail?.fileCode} />
            </div>
          </div>
        </div>
        <div className="ProjectPage-main" dir="ltr">
          <Canvas
            FilePath={fileDetail?.filePath}
            ToastsShow={setToastsShow}
            ToastsShowBack={setToastsShowBack}
            ToastsText={setToastsText}
          />
        </div>
        {loading && <LoadingModel />}
        <Toasts
          toastsShow={toastsShow}
          toastsText={toastsText}
          toastsShowBack={toastsShowBack}
        />
      </div>
    </>
  );
}
